<template>
    <div class="popups-wrapper">
        <STPopup ref="callbackPopupSidebar"
                 :icon-close-big="false"
                 modify="popup_middle_size popup_center_position">
            <Callback @close="hideCallbackForm" />
        </STPopup>

        <STPopup ref="brokerTourPopupSidebar"
                 :icon-close-big="false"
                 modify="popup_middle_size popup_center_position"
                 @popup-close="hideRequestBrokerTourForm">
            <RequestBrokerTour @close="hideRequestBrokerTourForm" />
        </STPopup>

        <STPopup ref="uniqueCheckPopup"
                 :icon-close-big="false"
                 modify="popup_middle_size popup_center_position">
            <UniqueCheck @close="hideUniqueCheckForm" />
        </STPopup>

        <STPopup ref="informationForClientPopup"
                 :icon-close-big="false"
                 modify="popup_middle_size popup_center_position">
            <InformationClient v-if="dataFirstPopup"
                               :button-text="dataFirstPopup.button"
                               @close="hideInformationForClient">
                <template #title>
                    {{ dataFirstPopup.title }}
                </template>
                <template #text>
                    <div v-html="dataFirstPopup.text" />
                </template>
            </InformationClient>
        </STPopup>
    </div>
</template>

<script>
import Callback from '@/components/Forms/RequestCallback/RequestCallback';
import InformationClient from '@/components/InformationClient/InformationClient.vue';
import RequestBrokerTour from '@/components/Forms/RequestBrokerTour/RequestBrokerTour';
import UniqueCheck from '@/components/Forms/UniqueCheck/UniqueCheck';
import {mapActions, mapGetters} from 'vuex';

export default {
    name: 'ThePopups',

    components: {
        Callback,
        InformationClient,
        RequestBrokerTour,
        UniqueCheck
    },

    data() {
        return {
            isFirstPopupShow: false,
            isPopupFromLink : false
        };
    },

    computed: {
        ...mapGetters({
            isActiveFirstPopup: 'GET_IS_FIRST_POPUP_STATUS',
            dataFirstPopup    : 'GET_DATA_FIRST_POPUP',
            isAuthenticated   : 'GET_IS_AUTHENTICATED'
        }),

        isPdf() {
            return this.$route.meta.pdf || false;
        }
    },

    watch: {
        isActiveFirstPopup(val) {
            if (val && !this.isFirstPopupShow && !this.isPopupFromLink) {
                this.isFirstPopupShow = true;

                setTimeout(() => {
                    this.showInformationForClient();
                }, 1500);
            }
        },
    },

    created() {
        const shouldOpenCallback = sessionStorage.getItem('pendingCallback') === '1';

        if (shouldOpenCallback && this.isAuthenticated && !this.isPdf) {
            sessionStorage.removeItem('pendingCallback');

            this.isPopupFromLink = true;
            this.$nextTick(() => {
                this.showRequestBrokerTourForm();
            });
        } else {
            this.getInfoFromFirstPopup();
        }


    },

    mounted() {
        if (this.isActiveFirstPopup && !this.isFirstPopupShow && !this.isPopupFromLink) {
            this.showInfoPopup();
        }
    },

    methods: {
        ...mapActions(['getInfoFromFirstPopup']),

        showInfoPopup() {
            this.isFirstPopupShow = true;

            setTimeout(() => {
                this.showInformationForClient();
            }, 1500);
        },

        showCallbackForm() {
            this.$refs.callbackPopupSidebar.open();
        },

        hideCallbackForm() {
            this.$refs.callbackPopupSidebar.close();
        },

        showUniqueCheckForm() {
            this.$refs.uniqueCheckPopup.open();
        },

        hideUniqueCheckForm() {
            this.$refs.uniqueCheckPopup.close();
        },

        showRequestBrokerTourForm() {
            this.$refs.brokerTourPopupSidebar.open();
        },

        hideRequestBrokerTourForm() {
            if (this.isPopupFromLink) {
                this.isPopupFromLink = false;

                if (this.isActiveFirstPopup && !this.isFirstPopupShow) {
                    this.showInfoPopup();
                } else {
                    this.getInfoFromFirstPopup();
                }
            }

            this.$refs.brokerTourPopupSidebar.close();
        },

        showInformationForClient() {
            this.$refs.informationForClientPopup.open();
        },

        hideInformationForClient() {
            this.$refs.informationForClientPopup.close();
        }
    }
};
</script>

<style lang="scss">
@import "Popup";
</style>
